
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class LoadedChatFromQueueDialog extends Vue {
  private visible: boolean = true;

  get message(): string {
    return 'You have 1 chat in the queue. Please review the chat before finishing your feedbacks.';
  }

  private destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
